/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { nullReducer, payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import type { ActionTypes, SignUp } from '../../types'
import { clearFieldErrorReducer } from '../signIn/reducer'
import {
  CLEAR_SIGN_UP,
  CLEAR_SIGN_UP_FIELD_ERROR,
  SET_SIGN_UP_ERROR,
  SET_SIGN_UP_FIRST_NAME,
  SET_SIGN_UP_LAST_NAME,
  SET_SIGN_UP_PHONE,
} from './constants'

export const signUpReducer = combineReducers<SignUp, ActionTypes>({
  error: handleActions<SignUp['error'], ActionTypes>(
    {
      [CLEAR_SIGN_UP]: nullReducer,
      [CLEAR_SIGN_UP_FIELD_ERROR]: clearFieldErrorReducer,
      [SET_SIGN_UP_ERROR]: payloadReducer,
    },
    null
  ),
  firstName: handleActions<SignUp['firstName'], ActionTypes>(
    { [CLEAR_SIGN_UP]: nullReducer, [SET_SIGN_UP_FIRST_NAME]: payloadReducer },
    null
  ),
  lastName: handleActions<SignUp['lastName'], ActionTypes>(
    { [CLEAR_SIGN_UP]: nullReducer, [SET_SIGN_UP_LAST_NAME]: payloadReducer },
    null
  ),
  phone: handleActions<SignUp['phone'], ActionTypes>(
    { [CLEAR_SIGN_UP]: nullReducer, [SET_SIGN_UP_PHONE]: payloadReducer },
    null
  ),
})
